import { createContext as a, useContext as d, useMemo as c, useState as u, useCallback as m, useEffect as x } from "react";
import { useThemeUI as p } from "@theme-ui/core";
import { isBrowser as M } from "@material-bank/ds-utils";
import { jsx as v } from "theme-ui/jsx-runtime";
const w = (e) => M() ? e.filter((t) => {
  const o = t.includes("@media") ? t.replace("@media ", "") : `screen and (min-width: ${t})`;
  return window.matchMedia(o).matches;
}) : [], f = (e) => w(e).length, h = () => {
  const {
    theme: e
  } = p(), t = c(() => (e == null ? void 0 : e.breakpoints) || [], [e == null ? void 0 : e.breakpoints]), [o, s] = u(void 0), n = m(() => {
    const i = f(t);
    s(i);
  }, [t]);
  return x(() => (window.addEventListener("resize", n), n(), () => window.removeEventListener("resize", n)), [n]), o;
}, r = a({
  breakpointIndex: void 0
}), b = ({
  children: e
}) => {
  const t = h();
  return /* @__PURE__ */ v(r.Provider, {
    value: {
      breakpointIndex: t
    },
    children: e
  });
}, g = () => d(r);
export {
  r as MatchMediaContext,
  b as MatchMediaProvider,
  g as useMatchMediaContext
};
